import { Link } from 'react-router';
import { ArrowRight } from 'lucide-react';

interface StickyMobileCTAProps {
  to: string;
  label: string;
}

/**
 * Sticky bottom CTA shown only on mobile (CSS-gated).
 * Used on landing-style pages where the primary action
 * (e.g. start wizard) should always be one thumb-tap away.
 */
export function StickyMobileCTA({ to, label }: StickyMobileCTAProps) {
  return (
    <div className="sticky-mobile-cta" aria-hidden={false}>
      <Link to={to} className="btn btn-primary sticky-mobile-cta__btn">
        <span>{label}</span>
        <ArrowRight size={16} strokeWidth={2} />
      </Link>
    </div>
  );
}
